import { createWebmanifestHandler } from '@goodlok/react-sdk/src/next/createWebmanifestHandler'

export const shortName = 'Směny'
export const description = 'Organizace směn.'

export default createWebmanifestHandler(shortName, description)
